import {
  getFormFieldSelectValidValue,
  getNextMultiSelectAllValue,
  getNextMultiSelectValue,
} from './FormFieldSelectNG.utils'

function FormFieldSelectNG({
  Select,
  getValidValue = getFormFieldSelectValidValue,
  multi,
  value,
  withEntityCreationFromSearchValue,
  onChange,
  ...restProps
}) {
  function handleSelectItem(nextValue) {
    if (multi) {
      onChange(getNextMultiSelectValue(value, nextValue))
    } else if (value?.value !== nextValue?.value) {
      onChange(nextValue)
    }
  }

  function handleSelectAll(nextValue) {
    onChange(multi ? getNextMultiSelectAllValue(value, nextValue) : nextValue)
  }

  function handleChangeSearch(nextValue) {
    if (!multi && withEntityCreationFromSearchValue) {
      onChange(nextValue)
    }
  }

  return (
    <Select
      {...restProps}
      multi={multi}
      value={getValidValue(value)} // prevent passing string value by default
      onChangeSearch={handleChangeSearch}
      onSelectAll={handleSelectAll}
      onSelectItem={handleSelectItem}
    />
  )
}

export default FormFieldSelectNG
